import { userReducer } from "./user/reducer"
import { combineReducers } from "redux"

// Here we could define multiple stores, for now we have only one for the user information.
export const rootReducer = combineReducers({
  user: userReducer,
})

export type RootState = ReturnType<typeof rootReducer>
